module.exports = __webpack_public_path__ + "static/media/beast_mode.relax.091fd0b5.jpeg";